import { createFileRoute } from "@tanstack/react-router";
import CompareCargowise from "@/pages/CompareCargowise";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/zh/compare/cargonova-vs-cargowise")({
  head: () => pageHead("/compare/cargonova-vs-cargowise", "zh"),
  component: CompareCargowise,
});
